<template>
  <v-app id="app">
    <v-navigation-drawer
      style="background: #f5f5f5"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.mdAndUp"
      app
    >
      <v-list dense nav class="pa-0" flat>
        <v-list-item
          @click.stop="drawer = !drawer"
          v-if="$vuetify.breakpoint.smOnly || $vuetify.breakpoint.xsOnly"
          style="height: 56px; background-color: #c2c2bc"
          class="px-4 mx-0"
        >
          <v-list-item-icon class="mt-4">
            <v-icon>mdi-chevron-left</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>ปิดเมนู</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item-group mandatory color="#cb1a1a" class="py-4 pl-2">
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            class="pr-0 py-1"
            :to="item.path"
            style="font-size: 14px; font-weight: 400"
          >
            <v-list-item-icon class="mr-4">
              <v-img
                contain
                v-if="current_path == item.path"
                width="20"
                :src="item.active_img"
              ></v-img>
              <v-img contain v-else width="20" :src="item.img"></v-img>
              <!-- <v-icon :size="index==1?'19':index==6?'24':'22'">{{ item.icon }}</v-icon> -->
              <!-- <v-img
                v-if="!active&&index==0"
                width="20px"
                src="../../src/assets/image/icon/promotion_ic.svg"
              />
              <v-img
                v-if="active&&index==0"
                width="20px"
                src="../../src/assets/image/icon/promotion_ic2.png"
              />
              <v-img
                v-if="!active&&index==1"
                width="20px"
                src="../../src/assets/image/icon/aboutus_ic1.png"
              />
              <v-img
                v-if="active&&index==1"
                width="20px"
                src="../../src/assets/image/icon/aboutus_ic2.png"
              />
              <v-img
                v-if="index==2"
                width="20px"
                src="../../src/assets/image/icon/location_ic.svg"
              />-->
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="font-kanit-light">{{
                item.title
              }}</v-list-item-title>
            </v-list-item-content>
            <v-divider
              v-if="current_path == item.path"
              style="background-color: #c93128; border: 1.2px solid #c93128"
              vertical
            ></v-divider>
          </v-list-item>

          <!-- <v-divider class="my-2 mt-4"></v-divider>
          <v-list-item
            v-for="(item_setting) in items_setting"
            :key="item_setting.title"
            class="pr-0"
            :to="item_setting.path"
          >
            <v-list-item-icon>
              <v-icon size="24">{{ item_setting.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="font-kanit-light">{{ item_setting.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>-->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      app
      color="secondary"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
        :style="
          mobile
            ? 'color:white!important;font-size:13px'
            : $vuetify.breakpoint.xsOnly
            ? 'color:white!important;font-size:16px'
            : x_tablet
            ? 'color:white!important;font-size:16px'
            : $vuetify.breakpoint.smOnly
            ? 'color:white!important;font-size:18px'
            : 'color:white!important;'
        "
        :class="
          $vuetify.breakpoint.xs
            ? 'pl-0 font-kanit-bold'
            : x_tablet
            ? 'ml-1 pl-0 font-kanit-bold'
            : $vuetify.breakpoint.sm
            ? 'ml-1 font-kanit-bold'
            : 'ml-6 font-kanit-bold'
        "
        >เว็บไซต์จัดการข้อมูลบนโมบายแอปพลิเคชัน</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-divider
        :class="!$vuetify.breakpoint.xsOnly ? 'mx-4' : 'mx-2'"
        inset
        vertical
      ></v-divider>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            text
            v-on="on"
            :large="!$vuetify.breakpoint.xsOnly"
            :icon="$vuetify.breakpoint.xsOnly"
          >
            <!-- <pre>{{profile[0].fname}}</pre> -->
            <v-icon size="16" class="mr-2" v-if="!$vuetify.breakpoint.xsOnly"
              >fas fa-user</v-icon
            >

            <span v-if="!$vuetify.breakpoint.xsOnly" class="font-kanit-bold">{{
              profile ? profile.fname + " " + profile.lname : ""
            }}</span>

            <v-icon small :right="!$vuetify.breakpoint.xsOnly"
              >mdi-chevron-down</v-icon
            >
          </v-btn>
        </template>
        <v-list class="py-0">
          <v-list-item
            class="pl-5"
            style="background: #e7e7e4"
            dense
            v-if="$vuetify.breakpoint.xsOnly"
          >
            <v-list-item-title class="font-kanit-bold">
              <v-icon size="16" class="mr-3">fas fa-user</v-icon>
              {{ profile ? profile.fname + " " + profile.lname : "" }}
            </v-list-item-title>
          </v-list-item>
          <!-- <v-divider color="#e7e7e4" v-if="$vuetify.breakpoint.xsOnly"></v-divider> -->
          <v-list-item dense @click="openResetPassword">
            <v-list-item-title>
              <v-icon left>mdi-key</v-icon>เปลี่ยนรหัสผ่าน
            </v-list-item-title>
          </v-list-item>
          <!-- <v-list-item to="/settings" v-show="permission_item_settings">
            <v-list-item-title>
              <v-icon left>mdi-settings</v-icon>ตั้งค่าระบบ
            </v-list-item-title>
          </v-list-item>-->
          <v-list-item dense @click="logout()">
            <v-list-item-title>
              <v-icon left>mdi-exit-to-app</v-icon>ออกจากระบบ
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Google Contacts</span>
      </v-toolbar-title>
      <v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-btn icon large>
        <v-avatar size="32px" item>
          <v-img src="https://cdn.vuetifyjs.com/images/logos/logo.svg" alt="Vuetify"></v-img>
        </v-avatar>
      </v-btn>-->
    </v-app-bar>
    <v-main
      ><v-container
        fluid
        :class="$vuetify.breakpoint.xsOnly ? 'px-4 py-2 pb-10' : 'px-4 pb-10'"
      >
        <!-- <div :class="$vuetify.breakpoint.xsOnly ? 'px-4 py-2 pb-10' : 'px-4 pb-10'"> -->
        <router-view></router-view>
        <!-- </div> -->
      </v-container></v-main
    >

    <DialogChangePassword ref="reset_password" />
  </v-app>
</template>

<script>
import DialogChangePassword from "../dialogsetting/dialogChangePassword";
export default {
  components: { DialogChangePassword },
  data() {
    return {
      drawer: null,
      profile: [],
      // items: [
      //   { icon: "mdi-contacts", text: "Contacts" },
      //   { icon: "mdi-history", text: "Frequently contacted" },
      //   { icon: "mdi-content-copy", text: "Duplicates" },
      //   {
      //     icon: "mdi-chevron-up",
      //     "icon-alt": "mdi-chevron-down",
      //     text: "Labels",
      //     model: true,
      //     children: [{ icon: "mdi-plus", text: "Create label" }]
      //   },
      //   {
      //     icon: "mdi-chevron-up",
      //     "icon-alt": "mdi-chevron-down",
      //     text: "More",
      //     model: false,
      //     children: [
      //       { text: "Import" },
      //       { text: "Export" },
      //       { text: "Print" },
      //       { text: "Undo changes" },
      //       { text: "Other contacts" }
      //     ]
      //   },
      //   { icon: "mdi-cog", text: "Settings" },
      //   { icon: "mdi-message", text: "Send feedback" },
      //   { icon: "mdi-help-circle", text: "Help" },
      //   { icon: "mdi-cellphone-link", text: "App downloads" },
      //   { icon: "mdi-keyboard", text: "Go to the old version" }
      // ]
      // drawer: false,
      // items: [
      //   { title: "โปรโมชั่น", icon: "fas fa-fire-alt",img:'',active_img:'', path: "/promotion" },
      //   { title: "เกี่ยวกับเรา", icon: "fas fa-users",img:'',active_img:'', path: "/aboutus" },
      //   { title: "สาขา", icon: "mdi-map-marker-radius",img:'',active_img:'', path: "/location" },
      //   {
      //     title: "ช่องทางสั่งซื้อ/บริการหลังการขาย",
      //     icon: "mdi-phone-forward",
      //     path: "/contact",img:'',active_img:'',
      //   },
      //   { title: "เจ้าหน้าที่", icon: "fas fa-user",img:'',active_img:'', path: "/staff" },
      //   { title: "รายงาน", icon: "fas fa-envelope-open-text",img:'',active_img:'', path: "/report" },
      // ],
      role_name: this.$session.get("role"),
      // right: null
    };
  },
  computed: {
    current_path() {
      return this.$route.fullPath;
    },
    items() {
      if (this.role_name == "Super Admin") {
        return [
          {
            title: "โปรโมชัน",
            icon: "fas fa-fire-alt",
            path: "/promotion",
            icon_image: "promotion_ic.png",
            img: require("@/assets/image/icon/promotion_ic.svg"),
            active_img: require("@/assets/image/icon/promotion_ic.png"),
          },
          {
            title: "เกี่ยวกับเรา",
            icon: "fas fa-users",
            path: "/aboutus",
            icon_image: "",
            img: require("@/assets/image/icon/aboutUs_ic.svg"),
            active_img: require("@/assets/image/icon/aboutUs_ic.png"),
          },
          {
            title: "สาขา",
            icon: "mdi-map-marker-radius",
            path: "/location",
            icon_image: "",
            img: require("@/assets/image/icon/location_ic.svg"),
            active_img: require("@/assets/image/icon/location_ic.png"),
          },
          {
            title: "ช่องทางสั่งซื้อ/บริการหลังการขาย",
            icon: "mdi-phone-forward",
            path: "/contact",
            icon_image: "",
            img: require("@/assets/image/icon/service_ic.svg"),
            active_img: require("@/assets/image/icon/service_ic.png"),
          },
          {
            title: "เจ้าหน้าที่",
            icon: "fas fa-user",
            path: "/staff",
            icon_image: "",
            img: require("@/assets/image/icon/employee_ic.svg"),
            active_img: require("@/assets/image/icon/employee_ic.png"),
          },
          {
            title: "รายงาน",
            icon: "fas fa-envelope-open-text",
            path: "/report",
            icon_image: "",
            img: require("@/assets/image/icon/report_ic.svg"),
            active_img: require("@/assets/image/icon/report_ic.png"),
          },
        ];
      } else if (this.role_name == "Admin") {
        return [
          {
            title: "โปรโมชัน",
            icon: "fas fa-fire-alt",
            path: "/promotion",
            icon_image: "promotion_ic.png",
            img: require("@/assets/image/icon/promotion_ic.svg"),
            active_img: require("@/assets/image/icon/promotion_ic.png"),
          },
          {
            title: "เกี่ยวกับเรา",
            icon: "fas fa-users",
            path: "/aboutus",
            icon_image: "",
            img: require("@/assets/image/icon/aboutUs_ic.svg"),
            active_img: require("@/assets/image/icon/aboutUs_ic.png"),
          },
          {
            title: "สาขา",
            icon: "mdi-map-marker-radius",
            path: "/location",
            icon_image: "",
            img: require("@/assets/image/icon/location_ic.svg"),
            active_img: require("@/assets/image/icon/location_ic.png"),
          },
          {
            title: "ช่องทางสั่งซื้อ/บริการหลังการขาย",
            icon: "mdi-phone-forward",
            path: "/contact",
            icon_image: "",
            img: require("@/assets/image/icon/service_ic.svg"),
            active_img: require("@/assets/image/icon/service_ic.png"),
          },
          {
            title: "เจ้าหน้าที่",
            icon: "fas fa-user",
            path: "/staff",
            icon_image: "",
            img: require("@/assets/image/icon/employee_ic.svg"),
            active_img: require("@/assets/image/icon/employee_ic.png"),
          },
          // {
          //   title: "รายงาน",
          //   icon: "fas fa-envelope-open-text",
          //   path: "/report",
          //   icon_image: "",
          //   img: require("@/assets/image/icon/report_ic.svg"),
          //   active_img: require("@/assets/image/icon/report_ic.png"),
          // },
        ];
      }
    },
    items_setting() {
      if (this.role_name == "Super Admin") {
        return [
          {
            title: "จังหวัด",
            icon: "mdi-map-marker-plus",
            path: "/province_setting",
          },
        ];
      } else if (this.role_name == "Admin") {
        return [
          {
            title: "จังหวัด",
            icon: "mdi-map-marker-plus",
            path: "/province_setting",
          },
        ];
      }
    },
    mobile() {
      if (this.$vuetify.breakpoint.width < 415) {
        return true;
      } else {
        return false;
      }
    },
    x_tablet() {
      if (
        this.$vuetify.breakpoint.width > 600 &&
        this.$vuetify.breakpoint.width < 650
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.profile = this.$session.get("profile");
    // console.log(this.profile);
  },
  methods: {
    logout() {
      this.$session.clear();
      this.$session.destroy();
      this.$router.push("/");
    },
    openResetPassword() {
      this.$refs.reset_password.openDialogChangePassword();
    },
  },
};
</script>